(() => {
  if (window.pkMenuPreviewReady) return;
  window.pkMenuPreviewReady = true;
  const pending = new Map();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const activeAnimations = new Set();
  const lifecycles = new WeakMap();
  function parseMenu(html) {
    const page = new DOMParser().parseFromString(html, 'text/html');
    return [...page.querySelectorAll('[data-pk-menu-section="food"] .pk-category')].map(header => {
      const items = [];
      let row = header.nextElementSibling;
      while (row && !row.matches('.pk-category')) {
        if (row.matches('.pk-print-dish')) items.push({name:row.querySelector('h3')?.textContent.trim(),price:row.querySelector('.pk-price')?.textContent.trim(),description:row.querySelector('p')?.textContent.trim(),dietary:row.querySelector('.pk-dietary')?.textContent.trim()});
        row = row.nextElementSibling;
      }
      return {name:header.querySelector('h2')?.textContent.trim(),note:header.querySelector('p')?.textContent.trim(),items};
    });
  }
  function source(url) {
    const target = new URL(url, location.href);
    if (target.origin !== location.origin) return Promise.reject(new Error('Menu must belong to this store.'));
    if (!pending.has(target.href)) pending.set(target.href, fetch(target.href, {credentials:'same-origin',signal:AbortSignal.timeout(12000)}).then(response => {
      if (!response.ok) throw new Error('Menu unavailable');
      return response.text();
    }).then(parseMenu));
    return pending.get(target.href);
  }
  const reviewFrame = document.querySelector('[data-pk-review-host]');
  if (reviewFrame) {
    window.addEventListener('message', async event => {
      if (event.source !== reviewFrame.contentWindow || event.data?.type !== 'pk-review-menu-request') return;
      try { reviewFrame.contentWindow.postMessage({type:'pk-review-menu-data',categories:await source(reviewFrame.dataset.menuUrl)}, '*'); }
      catch { reviewFrame.contentWindow.postMessage({type:'pk-review-menu-data',categories:[]}, '*'); }
    });
    return;
  }
  function loadSource(root) {
    if (document.body.dataset.pkReview !== 'true') return source(root.dataset.menuUrl);
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => { window.removeEventListener('message', receive); reject(new Error('Preview unavailable')); }, 12000);
      function receive(event) {
        if (event.source !== parent || event.data?.type !== 'pk-review-menu-data') return;
        clearTimeout(timeout); window.removeEventListener('message', receive); resolve(event.data.categories);
      }
      window.addEventListener('message', receive);
      parent.postMessage({type:'pk-review-menu-request'}, '*');
    });
  }
  function textElement(tag, value, className) {
    const element = document.createElement(tag); element.textContent = value;
    if (className) element.className = className;
    return element;
  }
  async function fill(root) {
    if (root.dataset.loaded) return;
    root.dataset.loaded = 'loading';
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    try {
      const categories = await loadSource(root);
      let total = 0;
      tabs.forEach((tab, index) => {
        const chosen = tab.dataset.sourceCategories.split('|').map(name => categories.find(category => category.name?.toLowerCase() === name.trim().toLowerCase())).filter(Boolean);
        const limit = Math.max(2, Math.min(4, Number(root.dataset.limit) || 3));
        const dishes = [];
        for (let round = 0; dishes.length < limit && round < limit; round++) chosen.forEach(category => {
          if (category.items[round] && dishes.length < limit) dishes.push(category.items[round]);
        });
        dishes.forEach(dish => {
          const article = document.createElement('article'); article.className = 'pk-preview-dish';
          const title = document.createElement('div'); title.className = 'pk-print-title';
          title.append(textElement('h3', dish.name),textElement('span', dish.price, 'pk-price')); article.append(title);
          if (dish.description) article.append(textElement('p', dish.description));
          if (dish.dietary) article.append(textElement('span',dish.dietary,'pk-dietary'));
          panels[index].append(article);
        });
        chosen.filter(category => category.note).forEach(category => panels[index].append(textElement('p',category.note,'pk-preview-condition')));
        tab.disabled = !dishes.length; total += dishes.length;
      });
      if (!total) throw new Error('No menu content');
      let selected = -1;
      let resizeObserver;
      const controller = new AbortController();
      const marker = root.querySelector('[data-preview-marker]');
      const motionAllowed = () => root.hasAttribute('data-pk-discovery') && root.dataset.motion === 'true' && document.body.dataset.pkMotion === 'true' && !reducedMotion.matches && !window.Shopify?.designMode;
      const localAnimations = new Set();
      function placeMarker() {
        if (!marker || selected < 0) return;
        marker.hidden = false;
        const tab = tabs[selected];
        marker.style.setProperty('--marker-x', `${tab.offsetLeft + Math.min(14, tab.offsetWidth / 8)}px`);
      }
      function animate(element, frames, duration) {
        if (!element || !motionAllowed()) return;
        const animation = element.animate(frames, {duration,easing:'cubic-bezier(.2,.65,.2,1)'});
        activeAnimations.add(animation);localAnimations.add(animation);
        animation.finished.catch(()=>{}).finally(()=>{activeAnimations.delete(animation);localAnimations.delete(animation);});
      }
      function select(index, focus = false) {
        if(index < 0 || !tabs[index] || tabs[index].disabled) return;
        const changed = selected !== index && selected !== -1;
        localAnimations.forEach(animation => animation.cancel());
        localAnimations.clear();
        tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index));tab.tabIndex = i === index ? 0 : -1;panels[i].hidden = i !== index;});
        root.querySelectorAll('[data-preview-photo]').forEach((photo, i) => {photo.hidden = i !== index;});
        selected = index;
        placeMarker();
        if(changed) {
          const phone = matchMedia('(max-width:767px)').matches;
          animate(panels[index],[{transform:`translateY(${phone ? 4 : 8}px)`},{transform:'translateY(0)'}],phone ? 150 : 220);
          animate(root.querySelector(`[data-preview-photo="${index}"]`),[{opacity:.88},{opacity:1}],phone ? 150 : 220);
        }
        if (focus) tabs[index].focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click',() => select(index),{signal:controller.signal});
        tab.addEventListener('keydown',event => {
          const keys = ['ArrowLeft','ArrowRight','Home','End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          const enabled = tabs.map((button,i)=>button.disabled ? -1 : i).filter(i=>i>=0);
          const current = enabled.indexOf(index);
          const next = event.key === 'Home' ? enabled[0] : event.key === 'End' ? enabled[enabled.length-1] : enabled[(current+(event.key==='ArrowRight'?1:enabled.length-1))%enabled.length];
          select(next,true);
        },{signal:controller.signal});
      });
      root.querySelector('[role="tablist"]').hidden = false;
      root.querySelector('[data-preview-status]').hidden = true;
      select(tabs.findIndex(tab => !tab.disabled));
      root.dataset.loaded = 'ready';
      if(marker && 'ResizeObserver' in window) {
        resizeObserver=new ResizeObserver(placeMarker);
        resizeObserver.observe(root.querySelector('[role="tablist"]'));
      }
      root.addEventListener('shopify:block:select',event=>{
        const photo=event.target.closest('[data-preview-photo]');
        if(photo)select(Number(photo.dataset.previewPhoto));
      },{signal:controller.signal});
      lifecycles.set(root,()=>{controller.abort();resizeObserver?.disconnect();localAnimations.forEach(animation=>animation.cancel());});
    } catch {root.dataset.loaded = 'failed';}
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-pk-preview]').forEach(root => {
      if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {fill(root);return;}
      const observer = new IntersectionObserver(entries => {if(entries.some(entry => entry.isIntersecting)){observer.disconnect();fill(root);}}, {rootMargin:'600px'});
      observer.observe(root);
    });
  }
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-pk-preview]').forEach(root=>lifecycles.get(root)?.()));
  reducedMotion.addEventListener('change',()=>{if(reducedMotion.matches){activeAnimations.forEach(animation=>animation.cancel());activeAnimations.clear();}});
  init();
})();
